var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":_vm.title,"visible":_vm.visible.loadingModal,"destroyOnClose":"","maskClosable":false,"width":"550px","footer":false,"closable":false}},[_c('a-progress',{attrs:{"percent":_vm.percent}}),_c('p',[_vm._v("正在加载配方数据")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }